"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[81],{

/***/ 76429:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24802);





var Icon = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 20 20"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M10.8347 4.16633C10.8347 3.70609 10.4616 3.33299 10.0014 3.33299C9.54114 3.33299 9.16805 3.70609 9.16805 4.16633V10.9049L6.84056 8.57741C6.51512 8.25198 5.98748 8.25198 5.66205 8.57741C5.33661 8.90285 5.33661 9.43049 5.66205 9.75592L8.82283 12.9167C9.4737 13.5676 10.529 13.5676 11.1798 12.9167L14.339 9.75755C14.6644 9.43212 14.6644 8.90448 14.339 8.57904C14.0136 8.2536 13.4859 8.2536 13.1605 8.57904L10.8347 10.9048V4.16633Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M3.33333 11.6667C3.79357 11.6667 4.16667 12.0398 4.16667 12.5V14.1667C4.16667 14.6269 4.53976 15 5 15H15C15.4602 15 15.8333 14.6269 15.8333 14.1667V12.5C15.8333 12.0398 16.2064 11.6667 16.6667 11.6667C17.1269 11.6667 17.5 12.0398 17.5 12.5V14.1667C17.5 15.5474 16.3807 16.6667 15 16.6667H5C3.61929 16.6667 2.5 15.5474 2.5 14.1667V12.5C2.5 12.0398 2.8731 11.6667 3.33333 11.6667Z",
                fill: "white"
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 19881:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24802);





var Icon = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: props.fill,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M9.58317 18.125C4.87484 18.125 1.0415 14.2917 1.0415 9.58332C1.0415 4.87499 4.87484 1.04166 9.58317 1.04166C14.2915 1.04166 18.1248 4.87499 18.1248 9.58332C18.1248 14.2917 14.2915 18.125 9.58317 18.125ZM9.58317 2.29166C5.55817 2.29166 2.2915 5.56666 2.2915 9.58332C2.2915 13.6 5.55817 16.875 9.58317 16.875C13.6082 16.875 16.8748 13.6 16.8748 9.58332C16.8748 5.56666 13.6082 2.29166 9.58317 2.29166Z",
                fill: props.fill
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M18.3335 18.9583C18.1752 18.9583 18.0169 18.9 17.8919 18.775L16.2252 17.1083C15.9835 16.8667 15.9835 16.4667 16.2252 16.225C16.4669 15.9833 16.8669 15.9833 17.1085 16.225L18.7752 17.8917C19.0169 18.1333 19.0169 18.5333 18.7752 18.775C18.6502 18.9 18.4919 18.9583 18.3335 18.9583Z",
                fill: props.fill
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 85656:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24802);





var Icon = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 40 40"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M16.6216 0.85942C18.7283 -0.286473 21.2721 -0.286474 23.3787 0.85942L35.5915 7.50256C37.8671 8.74033 39.2836 11.1233 39.2836 13.7137V26.2863C39.2836 28.8767 37.8671 31.2597 35.5915 32.4974L23.3787 39.1406C21.2721 40.2865 18.7283 40.2865 16.6216 39.1406L4.40883 32.4974C2.1333 31.2597 0.716797 28.8767 0.716797 26.2863L0.716797 13.7137C0.716797 11.1233 2.1333 8.74033 4.40882 7.50256L16.6216 0.85942Z",
                fill: "#F2B10A"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M20.75 22.52H20.98C21.31 22.52 21.59 22.22 21.59 21.85C21.59 21.38 21.48 21.32 21.16 21.21L20.75 21.07V22.52Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M20 10C14.48 10 10 14.48 10 20C10 25.52 14.48 30 20 30C25.52 30 30 25.52 30 20C30 14.48 25.52 10 20 10ZM15.58 24.42C15.87 24.71 15.87 25.19 15.58 25.48C15.43 25.63 15.24 25.7 15.05 25.7C14.86 25.7 14.67 25.63 14.52 25.48C13.06 24.02 12.25 22.07 12.25 20C12.25 17.93 13.06 15.98 14.52 14.52C14.81 14.23 15.29 14.23 15.58 14.52C15.87 14.81 15.87 15.29 15.58 15.58C14.4 16.76 13.75 18.33 13.75 20C13.75 21.67 14.4 23.24 15.58 24.42ZM21.65 19.78C22.61 20.12 23.08 20.79 23.08 21.84C23.08 23.04 22.14 24.01 20.97 24.01H20.74V24.19C20.74 24.6 20.4 24.94 19.99 24.94C19.58 24.94 19.24 24.6 19.24 24.19V24.01H19.21C17.94 24.01 16.9 22.94 16.9 21.63C16.9 21.22 17.24 20.88 17.65 20.88C18.06 20.88 18.4 21.22 18.4 21.63C18.4 22.12 18.76 22.51 19.21 22.51H19.24V20.53L18.34 20.21C17.38 19.87 16.91 19.2 16.91 18.15C16.91 16.95 17.85 15.98 19.02 15.98H19.25V15.8C19.25 15.39 19.59 15.05 20 15.05C20.41 15.05 20.75 15.39 20.75 15.8V15.98H20.78C22.05 15.98 23.09 17.05 23.09 18.36C23.09 18.77 22.75 19.11 22.34 19.11C21.93 19.11 21.59 18.77 21.59 18.36C21.59 17.87 21.23 17.48 20.78 17.48H20.75V19.46L21.65 19.78ZM25.48 25.48C25.33 25.63 25.14 25.7 24.95 25.7C24.76 25.7 24.57 25.63 24.42 25.48C24.13 25.19 24.13 24.71 24.42 24.42C25.6 23.24 26.25 21.67 26.25 20C26.25 18.33 25.6 16.76 24.42 15.58C24.13 15.29 24.13 14.81 24.42 14.52C24.71 14.23 25.19 14.23 25.48 14.52C26.94 15.98 27.75 17.93 27.75 20C27.75 22.07 26.94 24.02 25.48 25.48Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M18.4199 18.16C18.4199 18.63 18.5299 18.69 18.8499 18.8L19.2599 18.94V17.48H19.0299C18.6899 17.48 18.4199 17.79 18.4199 18.16Z",
                fill: "white"
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 68938:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24802);





var Icon = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 40 40"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M16.6216 0.85942C18.7283 -0.286473 21.2721 -0.286474 23.3787 0.85942L35.5915 7.50256C37.8671 8.74033 39.2836 11.1233 39.2836 13.7137V26.2863C39.2836 28.8767 37.8671 31.2597 35.5915 32.4974L23.3787 39.1406C21.2721 40.2865 18.7283 40.2865 16.6216 39.1406L4.40883 32.4974C2.1333 31.2597 0.716797 28.8767 0.716797 26.2863L0.716797 13.7137C0.716797 11.1233 2.1333 8.74033 4.40882 7.50256L16.6216 0.85942Z",
                fill: "#355DFF"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M22.9097 10.26C21.6797 10.26 20.6797 11.26 20.6797 12.49V17.13C20.6797 18.36 21.6797 19.36 22.9097 19.36C24.1397 19.36 25.1397 18.36 25.1397 17.13V12.49C25.1397 11.27 24.1397 10.26 22.9097 10.26Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                opacity: "0.4",
                d: "M28.5494 15.49C27.4794 15.49 26.6094 16.36 26.6094 17.43V19C26.6094 19.21 26.7794 19.38 26.9894 19.38H28.5594C29.6294 19.38 30.4994 18.51 30.4994 17.44C30.4994 16.37 29.6194 15.49 28.5494 15.49Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M16.87 15.37H12.23C11 15.37 10 16.37 10 17.6C10 18.83 11 19.83 12.23 19.83H16.87C18.1 19.83 19.1 18.83 19.1 17.6C19.1 16.37 18.1 15.37 16.87 15.37Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                opacity: "0.4",
                d: "M17.1597 10C16.0897 10 15.2197 10.87 15.2197 11.94C15.2197 13.01 16.0897 13.88 17.1597 13.88H18.7297C18.9397 13.88 19.1097 13.71 19.1097 13.5V11.93C19.0997 10.88 18.2297 10 17.1597 10Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M17.8003 21.41C16.5703 21.41 15.5703 22.41 15.5703 23.64V28.28C15.5703 29.51 16.5703 30.51 17.8003 30.51C19.0303 30.51 20.0303 29.51 20.0303 28.28V23.64C20.0303 22.41 19.0303 21.41 17.8003 21.41Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                opacity: "0.4",
                d: "M13.7297 21.41H12.1597C11.0897 21.41 10.2197 22.28 10.2197 23.35C10.2197 24.42 11.0897 25.29 12.1597 25.29C13.2297 25.29 14.0997 24.42 14.0997 23.35V21.78C14.0997 21.58 13.9297 21.41 13.7297 21.41Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M28.4794 20.95H23.8394C22.6094 20.95 21.6094 21.95 21.6094 23.18C21.6094 24.41 22.6094 25.41 23.8394 25.41H28.4794C29.7094 25.41 30.7094 24.41 30.7094 23.18C30.7094 21.95 29.7094 20.95 28.4794 20.95Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                opacity: "0.4",
                d: "M23.5496 26.85H21.9796C21.7696 26.85 21.5996 27.02 21.5996 27.23V28.8C21.5996 29.87 22.4696 30.74 23.5396 30.74C24.6096 30.74 25.4796 29.87 25.4796 28.8C25.4896 27.72 24.6196 26.85 23.5496 26.85Z",
                fill: "white"
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 83906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24802);





var Icon = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 40 40"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M16.6216 0.85942C18.7283 -0.286473 21.2721 -0.286474 23.3787 0.85942L35.5915 7.50256C37.8671 8.74033 39.2836 11.1233 39.2836 13.7137V26.2863C39.2836 28.8767 37.8671 31.2597 35.5915 32.4974L23.3787 39.1406C21.2721 40.2865 18.7283 40.2865 16.6216 39.1406L4.40883 32.4974C2.1333 31.2597 0.716797 28.8767 0.716797 26.2863L0.716797 13.7137C0.716797 11.1233 2.1333 8.74033 4.40882 7.50256L16.6216 0.85942Z",
                fill: "#00ACED"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                "clip-path": "url(#clip0_141_39506)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M21.2393 16.3654L26.6196 10L32 16.3654H21.2393Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M29.4088 15.4273H23.9141V26.6374H29.4088V15.4273Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M21.9527 18.1331H16.458V26.6374H21.9527V18.1331Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M14.4947 22.3849H9V26.6366H14.4947V22.3849Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M29.4092 27.8741H9V30H29.4092V27.8741Z",
                        fill: "white"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_141_39506",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "23",
                        height: "20",
                        fill: "white",
                        transform: "translate(9 10)"
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 38047:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _pancakeswap_localization__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13193);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_meta_tags__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(81372);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(94589);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(6538);
/* harmony import */ var _pancakeswap_uikit_src_widgets_Menu_config__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(4449);
/* harmony import */ var config_constants_meta__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31574);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: 100%;\n    height: auto;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    overflow: hidden;\n    position: relative;\n    margin-top: -",
        "px;\n    background-color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    max-width: 1320px;\n    width: 100%;\n    height: 100%;\n    min-height: 100vh;\n    padding-top: 30px;\n    z-index: 101;\n    margin-top: ",
        "px;\n    @media screen and (min-width: 769px) and (max-width: 1280px) {\n        padding-left: 30px !important;\n        padding-right: 30px !important;\n    }\n    @media screen and (min-width: 601px) and (max-width: 768px) {\n        padding-left: 10px;\n        padding-right: 10px;\n    }\n    @media screen and (max-width: 600px) {\n        padding-left: 10px;\n        padding-right: 10px;\n    }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





// import { useLocation } from 'react-router'




var PageMeta = function() {
    var ref = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)(), t = ref.t, locale = ref.currentLanguage.locale;
    var pathname = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)().pathname;
    var pageMeta = (0,config_constants_meta__WEBPACK_IMPORTED_MODULE_4__/* .getCustomMeta */ .S)(pathname, t, locale) || {};
    var ref1 = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, config_constants_meta__WEBPACK_IMPORTED_MODULE_4__/* .DEFAULT_META */ .k, pageMeta), title = ref1.title, description = ref1.description, image = ref1.image;
    var pageTitle = title;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_meta_tags__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("title", {
                children: pageTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                property: "og:image",
                content: image
            })
        ]
    });
};
var PageFullWidth = function(_param) {
    var children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(PageMeta, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CsContainer, {
                children: children
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PageFullWidth);
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d2db805b-0"
})(_templateObject(), _pancakeswap_uikit_src_widgets_Menu_config__WEBPACK_IMPORTED_MODULE_10__/* .MENU_HEIGHT */ .d0, function(param) {
    var theme = param.theme;
    return theme.colors.background;
});
var CsContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z).withConfig({
    componentId: "sc-d2db805b-1"
})(_templateObject1(), _pancakeswap_uikit_src_widgets_Menu_config__WEBPACK_IMPORTED_MODULE_10__/* .MENU_HEIGHT */ .d0);


/***/ }),

/***/ 48595:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ Paginate; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94974);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29439);
/* harmony import */ var react_paginate__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11358);
/* harmony import */ var react_paginate__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_paginate__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94589);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: 100%;\n    margin-bottom: 1rem;\n    justify-content: center;\n    height: 62px;\n    .pagination {\n        display: flex;\n        flex-direction: row;\n        justify-content: space-around;\n        align-items: center;\n        @media screen and (max-width: 600px) {\n            width: 100%;\n            justify-content: center;\n        }\n        * {\n            list-style-type: none;\n        }\n    }\n    .page-item {\n        margin: 0 0.375rem;\n        &:first-child,\n        &:last-child {\n            a {\n                &:hover {\n                    color: #f78e01;\n                    border: none !important;\n                }\n            }\n        }\n        &:first-child,\n        &:last-child {\n            a {\n                border: none;\n                background: none !important;\n            }\n        }\n        &:last-child.disabled,\n        &:first-child.disabled {\n            cursor: not-allowed;\n        }\n        border: 1px solid ",
        ";\n        border-radius: 12px;\n    }\n    .page-link {\n        width: 42px;\n        height: 42px;\n        display: flex;\n        background: #fff;\n        align-items: center;\n        justify-content: center;\n        border-radius: 12px;\n        color: ",
        ";\n        border: 1px solid ",
        ";\n        svg path {\n            fill: ",
        ";\n        }\n        @media screen and (max-width: 768px) {\n            padding: 12px;\n        }\n        &:focus {\n            box-shadow: none !important;\n        }\n        &:hover {\n            border: 2px solid ",
        ";\n            color: ",
        ";\n        }\n        @media screen and (max-width:600px) {\n            width: 32px;\n            height: 32px; \n            border-radius: 6px;\n            font-size: 12px;\n            padding: 8px;\n        }\n    }\n    .page-item.disabled .page-link {\n        background: ",
        ";\n        cursor: not-allowed !important;\n        opacity: 0.7;\n        pointer-events: none;\n        svg {\n            border-radius: 100%;\n        }\n        svg path {\n            fill: #9596a6 !important;\n        }\n    }\n    .page-item.active .page-link {\n        border: none;\n        background: ",
        ";\n        color: ",
        ";\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var Paginate = function(param) {
    var total = param.total, pageSize = param.pageSize, pageActive = param.pageActive, handlePageClick = param.handlePageClick;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CustomFlex, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((react_paginate__WEBPACK_IMPORTED_MODULE_2___default()), {
            nextLabel: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                style: {
                    transform: "rotate(180deg)"
                }
            }),
            previousLabel: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {}),
            onPageChange: handlePageClick,
            pageCount: total,
            pageClassName: "page-item",
            pageLinkClassName: "page-link",
            previousClassName: "page-item",
            previousLinkClassName: "page-link",
            nextClassName: "page-item",
            nextLinkClassName: "page-link",
            breakLabel: "...",
            breakClassName: "page-item",
            breakLinkClassName: "page-link",
            containerClassName: "pagination",
            activeClassName: "active",
            renderOnZeroPageCount: null,
            forcePage: pageActive,
            pageRangeDisplayed: 2,
            marginPagesDisplayed: 2
        })
    });
};
var CustomFlex = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    componentId: "sc-ac53b568-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
}, function(param) {
    var theme = param.theme;
    return theme.colors.text;
}, function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
}, function(param) {
    var theme = param.theme;
    return theme.colors.text;
}, function(param) {
    var theme = param.theme;
    return theme.colors.primary;
}, function(param) {
    var theme = param.theme;
    return theme.colors.primary;
}, function(param) {
    var theme = param.theme;
    return theme.colors.disabled;
}, function(param) {
    var theme = param.theme;
    return theme.colors.primary;
}, function(param) {
    var theme = param.theme;
    return theme.colors.white;
});


/***/ }),

/***/ 20012:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ formatNumber; }
/* harmony export */ });
/* harmony import */ var bignumber_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70794);

var formatNumber = function(newValue, flag) {
    if (new bignumber_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(newValue).isNaN()) {
        return "0";
    }
    return Intl.NumberFormat("en-US", {
        maximumFractionDigits: 2
    }).format(new bignumber_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(newValue).decimalPlaces(0, 1).toNumber());
};


/***/ }),

/***/ 44293:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ renderDate; }
/* harmony export */ });
var renderDate = function() {
    var date = new Date();
    var days = date.getDate() < 10 ? "0".concat(date.getDate()) : date.getDate();
    var months = date.getMonth() + 1 < 10 ? "0".concat(date.getMonth() + 1) : date.getMonth() + 1;
    var hours = date.getHours() < 10 ? "0".concat(date.getHours()) : date.getHours();
    var minutes = date.getMinutes() < 10 ? "0".concat(date.getMinutes()) : date.getMinutes();
    var seconds = date.getSeconds() < 10 ? "0".concat(date.getSeconds()) : date.getSeconds();
    return "".concat(days).concat(months).concat(date.getFullYear(), "_").concat(hours).concat(minutes).concat(seconds);
};


/***/ }),

/***/ 11447:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29439);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74566);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(55604);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(55421);
/* harmony import */ var hooks_useTheme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63850);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var utils_formatNumber__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20012);





var Card = function(param) {
    var icon = param.icon, title = param.title, value = param.value, unit = param.unit, isLoading = param.isLoading;
    var theme = (0,hooks_useTheme__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)().theme;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        width: "100%",
        flexDirection: "column",
        style: {
            gap: "1rem"
        },
        border: "1px solid ".concat(theme.colors.cardBorder),
        borderRadius: "12px",
        padding: "1rem 2rem",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                width: "100%",
                children: /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.isValidElement)(icon) && /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.cloneElement)(icon)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                width: "100%",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    fontSize: "18px",
                    color: "textB9",
                    children: title
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                width: "100%",
                style: {
                    gap: "1rem"
                },
                alignItems: "center",
                children: [
                    isLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        width: "52px"
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        scale: "lg",
                        children: (0,utils_formatNumber__WEBPACK_IMPORTED_MODULE_3__/* .formatNumber */ .u)(value)
                    }),
                    unit && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        padding: "8px 8px 6px 8px",
                        background: theme.colors.green,
                        borderRadius: "8px",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            color: "white",
                            children: unit
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Card);


/***/ }),

/***/ 44331:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LN": function() { return /* binding */ ContainerLink; },
/* harmony export */   "_K": function() { return /* binding */ ContainerCard; },
/* harmony export */   "u": function() { return /* binding */ Tooltip; },
/* harmony export */   "vo": function() { return /* binding */ ContainerRow; },
/* harmony export */   "zd": function() { return /* binding */ Mask; }
/* harmony export */ });
/* unused harmony export StyledButtonDownloadExcel */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29439);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94589);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: 100%;\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    grid-column-gap: 2rem;\n    @media screen and (max-width:1024px) and (min-width:768px) {\n        grid-template-columns: repeat(2, 1fr);\n        grid-gap: 2rem;\n    }\n    @media screen and (max-width:600px) {\n        grid-template-columns: 1fr;\n        grid-row-gap: 1rem;\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: 100%;\n    display: grid;\n    height: ",
        ";\n    align-items: center;\n    padding: 0rem 0rem 0rem 1rem;\n    border-radius: ",
        ";\n    grid-template-columns: 12% 19% 9% 16% 12% 16% 16%;\n    background: ",
        ";\n    border-bottom: ",
        ";\n    @media screen and (max-width:768px) {\n        display: ",
        ";\n    }\n    @media screen and (max-width:768px) {\n        grid-template-columns: 1fr;\n        grid-row-gap: 8px;\n        padding:1rem;\n        width: 100%;\n        max-width: 350px;\n        border: 1px solid ",
        ";\n        border-radius: 12px;\n        \n    }\n    @media screen and (max-width:600px) {\n        max-width: 100%;\n    }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    display: ",
        ";\n    position: absolute;\n    padding: 8px;\n    top: -35px;\n    right: -15px;\n    text-align: center;\n    background-color: #fff;\n    color: #000;\n    border-radius: 16px;\n    width: 100px;\n    box-shadow: 4px 4px 4px rgba(0, 0, 0, 0.1);\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: 100%;\n    height: 100%;\n    z-index: 10;\n    cursor:pointer;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    height: 68px;\n    width: 100%;\n    position: relative;\n    @media screen and (max-width:768px) {\n        height: 300px;\n        max-width: 350px;\n    }\n    @media screen and (max-width:600px) {\n        height: 400px;\n        max-width: 100%;\n    }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    position: relative;\n    background: ",
        ";\n    border-radius: 12px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-width: 130px;\n    height: 48px;\n    @media screen and (max-width: 768px) {\n        min-width: 40px;\n    }\n    div{\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        gap: 8px;\n        height: 36px;\n            p{\n                font-size: 14px;\n                padding: 0px;\n                color: ",
        ";\n                font-weight: bold;\n                @media screen and (max-width: 768px) {\n                    display: none;\n                }\n            }\n    }\n    .download-table-xls-button {\n        cursor: pointer;\n        position: absolute;\n        width: 100%;\n        height: 100%;\n        left: 0;\n        top: 0;\n        border: none;\n        background: none;\n    }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var ContainerCard = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-980d76d5-0"
})(_templateObject());
var ContainerRow = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-980d76d5-1"
})(_templateObject1(), function(param) {
    var isHeader = param.isHeader;
    return isHeader ? "58px" : "100%";
}, function(param) {
    var isHeader = param.isHeader;
    return isHeader ? "12px" : "0px";
}, function(param) {
    var isHeader = param.isHeader, theme = param.theme;
    return isHeader ? theme.colors.backgroundAlt2 : "transparent";
}, function(param) {
    var isHeader = param.isHeader, theme = param.theme;
    return !isHeader ? "1px solid ".concat(theme.colors.cardBorder) : "none";
}, function(param) {
    var isHeader = param.isHeader;
    return isHeader ? "none" : "grid";
}, function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
});
var Tooltip = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-980d76d5-2"
})(_templateObject2(), function(param) {
    var isTooltipDisplayed = param.isTooltipDisplayed;
    return isTooltipDisplayed ? "inline-block" : "none";
});
var Mask = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-980d76d5-3"
})(_templateObject3());
var ContainerLink = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-980d76d5-4"
})(_templateObject4());
var StyledButtonDownloadExcel = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-980d76d5-5"
})(_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.colors.primary;
}, function(param) {
    var theme = param.theme;
    return theme.colors.white;
});


/***/ })

}]);